/** Assets and timing for the cinematic Season Complete dialog. */

export const SEASON_COMPLETE_BGM_PATH = '/music/Ashes Cleared2.mp3';
export const SEASON_COMPLETE_FRAME_PATH = '/images/frame.png';
export const SEASON_COMPLETE_REVEAL1_SFX = '/sounds/reveal1.mp3';
export const SEASON_COMPLETE_REVEAL2_SFX = '/sounds/reveal2.mp3';

/** Fade duration for season-complete BGM transitions (ms). */
export const SEASON_COMPLETE_BGM_FADE_MS = 800;

export const SEASON_COMPLETE_TIMING = {
  introMs: 3000,
  fadeMs: 500,
  /** Start reveal1 this many ms before the matching visual reveal (build-up → boom). */
  reveal1LeadMs: 500,
  rankIntervalMs: 2000,
  rankCount: 5,
  /** Total ranks phase: last rank appears at (rankCount-1)*interval + lead, then hold one more interval. */
  ranksHoldMs: 2000 * 5 + 500,
  titleMs: 4000,
  rewardsMs: 5000,
};
